// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoI {\n  display: flex;\n  flex-direction: column;\n  margin: 0 !important;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: calc(100% - 30px);\n  max-width: calc(100% - 30px);\n}\n.infoI .el-dialog__header {\n    background-color: #ffffff;\n    border-bottom: none !important;\n}\n.infoI .el-dialog__body {\n    flex: 1;\n    overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
